import { BackgroundCheckColumns, backgroundCheckEntityName } from '@/backend/features/background-check/shared';
import { BackgroundCheckType } from '@/backend/features/background-check/types';
import { ExtendedAccountColumns } from '@/backend/features/contact-management/entities/extended-account/types';
import { mapBackgroundCheckFilter } from '@/ui/features/background-check/utils/mapBackgroundCheckFilter';
import { ExtendedAccountFilterData } from '@/ui/features/contact-management/AccountsPanel/types';
import { Filter, FilterIdSubFilter } from '@juvare/platform-shared/features/storage';

export function mapBackgroundCheckToAccountFilter(
    enabledTypes: BackgroundCheckType[],
    filterData: ExtendedAccountFilterData,
    expiringOnlyFilters: Filter<BackgroundCheckColumns>[],
    accountFilters?: Filter<ExtendedAccountColumns>[],
) {
    const { filter: backgroundCheckFilters, defaultFilters: defaultBackgroundCheckFilters } = mapBackgroundCheckFilter(
        enabledTypes,
        filterData,
        expiringOnlyFilters,
    );

    const filter: Filter<ExtendedAccountColumns>[] = [...(accountFilters ?? [])];
    const defaultFilters: Filter<BackgroundCheckColumns>[] = [
        {
            op: 'in',
            idSubFilter: {
                entity: backgroundCheckEntityName,
                column: 'accountId',
                filter: defaultBackgroundCheckFilters,
            } satisfies FilterIdSubFilter<BackgroundCheckColumns>['idSubFilter'],
        },
    ];

    if (backgroundCheckFilters?.length) {
        filter.push({
            op: 'in',
            idSubFilter: {
                entity: backgroundCheckEntityName,
                column: 'accountId',
                filter: backgroundCheckFilters,
            } satisfies FilterIdSubFilter<BackgroundCheckColumns>['idSubFilter'],
        });
    }

    return { filter, defaultFilters };
}
